import { TFunction } from "i18next";
import { number, object, ObjectSchema, string } from "yup";
import { fieldDefinedError } from "../../../shared/technical/rest/validation";

export interface TermsAndConditions {
  htmlText: string,
  version: number,
}

export function termsAndConditionsSchema(t: TFunction): ObjectSchema<TermsAndConditions> {
  return object({
    htmlText: string().trim().required(fieldDefinedError(t)),
    version: number().default(0).required(fieldDefinedError(t)),
  })
}
